<template>
  <div class="group relative h-12 w-48 flex items-center rounded-lg bg-white shadow-lg text-gray-600">
    <div class="shrink-0 px-2">
      <FileOutline class="h-6 w-6 text-gray-300 mx-4" aria-hidden="true" />
    </div>
    <div class="grow text-xs truncate">
      <div class="truncate">{{ file.name }}</div>
      <div v-if="file.size">{{ sizeHr(file.size) }}</div>
    </div>
    <div class="shrink-0">
      <slot />
    </div>
  </div>
</template>

<script setup>
import FileOutline from 'vue-material-design-icons/FileOutline.vue';

defineProps({
  file: {
    type: Object,
    default: () => {}
  }
});

function sizeHr(size) {
  let _size = size;
  const units = [ 'b', 'Kb', 'Mb', 'Gb', 'Tb' ];
  let unit = 0;
  while (_size > 1024) {
    _size /= 1024;
    unit++;
  }

  return `${_size.toFixed(2)} ${units[unit]}`;
}
</script>
